export class Task {
  public id: number;
  public tsEvent: string;
  public text: string;
  public timespendMin: number;
  public buildInSolution: number;
  public replied: number;
  public workerCode: string;
  public workerName: string;
  public communicationTypeNameSmall: string;
  public cooperationCode: string;
  public todoCode: string;
  public tsBooked: string;
  public nextContact: string;
  public statusNameSmall: string;
  public statusColor: number;
  public cooperationNameSmall: string;
  public partnerCode: string;
  public partnerTitleSmall: string;
  public numberOfUnreadMessages: number;
  public contactId: number;
  public workCodeCurrent: string;
  public workIdCurrent;
  public workFirstNameCurrent;
  public partnerId: string;
  public showNextContactCurrent: number;
  public completed: 0;
  public statusCode: string;
  public processCode: string;
}
